import { createRequest, RequestConfig } from '../../../core/libs/api';

const config: RequestConfig = {
  method: 'get',
  url: '/wagons',
};

export const getWagonRequest = (wagonId: number) =>
  createRequest({
    url: `${config.url}/${wagonId}.json`,
    method: config.method,
  });
